import React from 'react'
import { ToolTip } from './ToolTip'
import _ from 'common-tools/LodashHelper'

export class FAIcon extends React.Component {
  static defaultProps = {
    placement: 'top',
    size: null,
    htmlToolTip: false,
    dontApplyIconColor: false
  }

  render () {
    const { name, className, color, onClick, style, type, spin, toolTip, fixedWidth, placement, size, overlayClassName, htmlToolTip, dontApplyIconColor } = this.props

    let iconStyle = _.merge({}, style)

    if (size) {
      iconStyle.fontSize = size
    }

    const colorClassName = color ? `text-${color}` : ''
    const icon = <i onClick={onClick} style={iconStyle} className={`fa${type || 'd'} fa-${name} ${className || ''} ${dontApplyIconColor ? '' : colorClassName} ${spin ? 'fa-spin' : ''} ${fixedWidth ? 'fa-fw' : ''}`}></i>

    if (toolTip) {
      return (
        <ToolTip toolTip={toolTip} style={{ 'display': 'inline' }} placement={placement} overlayClassName={overlayClassName} htmlToolTip={htmlToolTip} color={color}>
          {icon}
        </ToolTip>
      )
    } else {
      return icon
    }
  }
}
